module.exports = __webpack_public_path__ + "static/media/icon_textarea.8f69c35d.svg";